import { COLORS } from '@Commons';
import { styled } from 'styled-components';

export const ModalWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.85);
  width: 100%;
  height: 100vh;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 30%;
  height: 30%;
  background: white;
  /* Light-Grey */

  border: 1px solid ${COLORS.borderGrey};
  box-sizing: border-box;
  box-shadow: 0px 10px 24px rgba(0, 0, 0, 0.1);
  border-radius: 10px;

  @media only screen and (max-width: 1080px) {
    width: 90%;
  }
`;

export const Close = styled.div`
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
  cursor: pointer;
`;

export const Content = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  button {
    margin-top: 10%;
  }
  text-align: center;
`;

export const CaptchaContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 24px 0;
`;

export const LoaderImage = styled.img`
  width: 200px;
  height: 200px;
  position: absolute;
  top: 50%;
  left: 65%;
  transform: translate(-50%, -50%);
  animation: loaderPulse 1.5s ease-in-out infinite;
`;
